import { ROLE_INFO, isMafiaTeam, type PlayerView } from '@mafia/core';
import { seatLabel } from '@/lib/format';

/** Карта роли на этапе раздачи: только своя роль и (для мафии) сообщники. */
export function RoleReveal({ view }: { view: PlayerView }) {
  const me = view.me;
  if (!me) return null;
  const info = ROLE_INFO[me.role];
  const mafia = isMafiaTeam(me.role);
  const teammates = mafia ? view.players.filter((p) => p.role && isMafiaTeam(p.role) && p.seat !== me.seat) : [];

  return (
    <div className="mx-auto my-6 max-w-sm [perspective:1000px]">
      <div
        className={`animate-flip rounded-3xl border p-6 text-center shadow-2xl ${
          mafia
            ? 'border-blood-600/40 bg-gradient-to-b from-blood-700/40 to-ink-900'
            : me.role === 'MANIAC'
              ? 'border-purple-500/40 bg-gradient-to-b from-purple-900/40 to-ink-900'
              : 'border-indigo-400/30 bg-gradient-to-b from-indigo-900/40 to-ink-900'
        }`}
      >
        <p className="text-sm uppercase tracking-[.3em] text-zinc-400">Ваша роль</p>
        <div className="my-4 text-7xl">{info.emoji}</div>
        <h2 className="font-display text-3xl">{info.name}</h2>
        <p className="mt-3 text-sm leading-relaxed text-zinc-300">{info.description}</p>
        {teammates.length > 0 && (
          <div className="mt-5 rounded-xl bg-black/30 p-3 text-sm">
            <p className="mb-1 text-zinc-400">Ваши сообщники:</p>
            {teammates.map((t) => (
              <p key={t.seat} className="text-blood-400">
                {seatLabel(view, t.seat)} — {ROLE_INFO[t.role!].name}
              </p>
            ))}
          </div>
        )}
        <p className="mt-5 text-xs text-zinc-500">Место за столом: №{me.seat}. Никому не показывайте экран.</p>
      </div>
    </div>
  );
}
